import { useUser } from "@dashboard/auth";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { Box, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { AccessLog } from "./AccessLog";
import { accessLogMessages } from "./messages";

const AccessLogSection = () => {
  const intl = useIntl();
  const user = useUser();

  return (
    <>
      <WindowTitle title={intl.formatMessage(accessLogMessages.sectionName)} />
      {user.user?.isSuperuser ? (
        <AccessLog />
      ) : (
        <Box padding={6}>
          <Text size={3}>{intl.formatMessage(accessLogMessages.adminOnly)}</Text>
        </Box>
      )}
    </>
  );
};

export default AccessLogSection;
